import type { EnvironmentConfig } from '@abb-procure/constants';
import { AuthenticationType } from 'azure-maps-control';

const apiEndpoint = 'https://api.dev.procure.abb.com/';
const instrumentationKey = '211d74ae-28bb-4587-b49f-90a539eba6e9';
const msalApiEndpointId = 'a854c4bd-71ca-42db-8ef9-8c5a331015eb';
const msalClientId = 'a854c4bd-71ca-42db-8ef9-8c5a331015eb';
const azureMapsSubscriptionKey = '4k7RGFD-ixDjf0coWPLhVfSJEkNshzlT3qEp19wQvQs';
const agGridLicenceKey =
  'Using_this_{AG_Grid}_Enterprise_key_{AG-102070}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{ABB_Information_Systems_Ltd}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{ABB_Procure}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{ABB_Procure}_need_to_be_licensed___{ABB_Procure}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_July_2027}____[v3]_[01]_MTgxNTYwNjAwMDAwMA==ec454acbec292d32f13020ac014d9507';

/**
 * This is the environment configuration for the 'develop' context of the project.
 *
 * The following contexts or environments are available:
 *  - development (environment.ts): For local development.
 *  - develop (environment.develop.ts): First deploy after merges. Development built for production.
 *  - staging (environment.staging.ts): Staging environment before production (acceptance tests).
 *  - production (environment.production.ts): Final stage for live application.
 */
export const environment: EnvironmentConfig = {
  production: true,
  title: 'Development',
  isEnvironmentBannerEnabled: true,
  apiEndpoint,
  msalApiEndpointResource: 'https://graph.windows.net',
  msalConfig: {
    apiEndpointId: msalApiEndpointId,
    clientId: msalClientId,
    instance:
      'https://login.microsoftonline.com/e77d828a-dd9f-4787-bd3c-3b21d7b14ce6/',
    cacheLocation: 'localStorage',
  },
  msalLoggingEnabled: false,
  signalrLoggingEnabled: true,
  instrumentationKey,
  mapOptions: {
    authOptions: {
      authType: AuthenticationType.subscriptionKey,
      subscriptionKey: azureMapsSubscriptionKey,
    },
    baseUrl: 'https://atlas.microsoft.com/',
    endpoints: {
      addressSearch: `search/address/json?&subscription-key=${azureMapsSubscriptionKey}&api-version=1.0&language=de-CH&query=`,
    },
  },
  agGridLicenceKey: agGridLicenceKey,
};
